export const MESSAGE_TYPE = {
  param: 'param',
  query: 'query',
};

export const EMOTION_TYPE = value => {
  let custom;
  switch (value) {
    case '1':
    case 'no':
      custom = '/images/emotiongif/no.gif';
      break;

    case '2':
    case 'yes':
      custom = '/images/emotiongif/yes.gif';
      break;

    case '3':
    case 'thanks':
    case 'th':
      custom = '/images/emotiongif/thanks.gif';
      break;

    case '4':
    case 'worry':
    case 'wo':
      custom = '/images/emotiongif/worry.gif';
      break;

    case 'cleanseo':
    case '5':
    case 'cs':
      custom = '/images/emotiongif/cleanseo.gif';
      break;

    case '6':
    case 'love':
    case 'lo':
      custom = '/images/emotiongif/love.gif';
      break;

    case '7':
    case 'communication1avenue':
    case 'ca':
      custom = '/images/emotiongif/communication1avenue.gif';
      break;

    case 'sad':
    case '8':
    case 'sa':
      custom = '/images/emotiongif/sad.gif';
      break;

    case 'eating':
    case '9':
    case 'ea':
      custom = '/images/emotiongif/eating.gif';
      break;

    case '10':
    case 'garbage':
    case 'ga':
      custom = '/images/emotiongif/garbage.gif';
      break;

    case '11':
    case 'encouragement':
    case 'en':
      custom = '/images/emotiongif/encouragement.gif';
      break;

    case '12':
    case 'cheerup':
    case 'ch':
      custom = '/images/emotiongif/cheerup.gif';
      break;

    case '13':
    case 'opinion':
    case 'op':
      custom = '/images/emotiongif/opinion.gif';
      break;

    case '14':
    case 'bye':
    case 'by':
      custom = '/images/emotiongif/bye.gif';
      break;

    case '15':
    case 'transference':
    case 'tr':
      custom = '/images/emotiongif/transference.gif';
      break;

    case '16':
    case 'joy':
    case 'jo':
      custom = '/images/emotiongif/joy.gif';
      break;

    case '17':
    case 'celebration':
    case 'ce':
      custom = '/images/emotiongif/celebration.gif';
      break;

    case '18':
    case 'birthnurture':
    case 'bn':
      custom = '/images/emotiongif/birthnurture.gif';
      break;

    case '19':
    case 'hobby':
    case 'ho':
      custom = '/images/emotiongif/hobby.gif';
      break;

    case '20':
    case 'dementia':
    case 'de':
      custom = '/images/emotiongif/dementia.gif';
      break;

    case '21':
    case 'friend':
    case 'fr':
      custom = '/images/emotiongif/friend.gif';
      break;

    case '22':
    case 'corona':
    case 'co':
      custom = '/images/emotiongif/corona.gif';
      break;

    case '23':
    case 'learning':
    case 'le':
      custom = '/images/emotiongif/learning.gif';
      break;

    case '24':
    case 'welcome':
    case 'we':
      custom = '/images/emotiongif/welcome.gif';
      break;

    case '25':
    case 'bicycle':
    case 'bi':
      custom = '/images/emotiongif/bicycle.gif';
      break;

    case '26':
    case 'angry':
      custom = '/images/emotiongif/angry.gif';
      break;

    case '27':
    case 'caution':
      custom = '/images/emotiongif/caution.gif';
      break;

    case '28':
    case 'christmas':
      custom = '/images/emotiongif/christmas.gif';
      break;

    case '29':
    case 'cold':
      custom = '/images/emotiongif/cold.gif';
      break;

    case '30':
    case 'congratulate':
      custom = '/images/emotiongif/congratulate.gif';
      break;

    case '31':
    case 'embarrassed':
      custom = '/images/emotiongif/embarrassed.gif';
      break;

    case '32':
    case 'flowerRoad':
      custom = '/images/emotiongif/flowerRoad.gif';
      break;

    case '33':
    case 'forbidden':
      custom = '/images/emotiongif/forbidden.gif';
      break;

    case '34':
    case 'greeting':
      custom = '/images/emotiongif/greeting.gif';
      break;

    case '35':
    case 'hot':
      custom = '/images/emotiongif/hot.gif';
      break;

    case '36':
    case 'ideas':
      custom = '/images/emotiongif/ideas.gif';
      break;

    case '37':
    case 'newyear':
      custom = '/images/emotiongif/newyear.gif';
      break;

    case '38':
    case 'pound':
      custom = '/images/emotiongif/pound.gif';
      break;

    case '39':
    case 'question':
      custom = '/images/emotiongif/question.gif';
      break;

    case '40':
    case 'smile':
      custom = '/images/emotiongif/smile.gif';
      break;

    case '41':
    case 'summer':
      custom = '/images/emotiongif/summer.gif';
      break;

    case '42':
    case 'thankyou':
      custom = '/images/emotiongif/thankyou.gif';
      break;

    case '43':
    case 'thumbsUp':
      custom = '/images/emotiongif/thumbsUp.gif';
      break;

    case '44':
    case 'winter':
      custom = '/images/emotiongif/winter.gif';
      break;

    case '45':
    case 'working':
      custom = '/images/emotiongif/working.gif';
      break;

    default:
      custom = '';
  }
  return custom;
};

export const WEATHER_TYPE = ['날씨', '체감온도', '비와'];

export const columns = [
  {
    Header: '목록',
    accessor: '목록',
  },
  {
    Header: '아니다(0점)',
    accessor: '아니다(0점)',
  },
  {
    Header: '가끔 그렇다(1점)',
    accessor: '가끔 그렇다(1점)',
  },
  {
    Header: '자주 그렇다(2점)',
    accessor: 'gender',
  },
];



/* 방문시간 */
export const visit = (days, time, passport) => {
  /* let days; */
  /* let time;
 *   let passport; */
  let result = [];
    if(days !==2 && passport === 'Y'){
    passport = 'N'
  }
  /* 평일 */
  if (days !== 0 && days !== 6 && passport !== 'Y') {
    if (time >= 9 && time < 16) {
      console.log('근무시간');
      result = [
        '현 시간 민원 업무는 순항 중입니다. 업무 시간 내에 자유롭게 방문해주세요!',
        '민원 업무는 오후 6시까지 입니다. 방문 접수를 원하시는 구민께서는 내방해주시기 바랍니다.',
        '민원 안내는 오후 6시까지이며, 현재 방문이 가능합니다.',
      ];
    } else if (time >= 16 && time < 17) {
      console.log('마감 직전');
      result = [
        '민원 업무 시간이 얼마 남지 않았어요! 방문 접수를 원하시는 구민께서는 서둘러주세요!',
        '민원 안내는 오후 6시에 마감됩니다. 시간이 얼마 남지 않았어요!',
        '민원 업무는 18시에 종료됩니다. 가까운 곳에 계신다면 얼른 방문해주세요!',
      ];
    } else if (time >= 17 && time < 18) {
      console.log('마감 직전');
      result = [
        '업무 마감까지 1시간이 채 남지 않아, 금일 민원 접수를 위한 방문이 어려울 수 있습니다!',
        '금일 민원 업무는 18시까지예요! 방문을 다음 근무일로 미뤄주시기 바랍니다.',
        '오후 6시에 업무가 마감되므로 오늘은 민원 처리가 어려울 수도 있는 점 양해 부탁드립니다.',
      ];
    } else if (time >= 18 && time < 24) {
      console.log('근무시간 외');
      result = [
        '오늘의 민원 업무는 마감되었습니다. 다음 근무일에 방문해주시기 바랍니다.',
        '오늘은 업무가 마감되었습니다. 방문 접수를 하실 구민께서는 다음 근무일을 이용해주세요!',
        '금일 민원 업무가 마감되었습니다. 방문이 필요한 민원은 다음으로 미뤄주세요!',
      ];
    } else {
      console.log('근무시간 외');
      result = [
        '아직 업무 시작 전이에요. 구민분들의 민원을 처리하기 위해 저희도 열심히 준비 중입니다!',
        '업무 시작 시간은 오전 9시입니다. 잠시만 기다려주세요!',
        '민원 업무는 오전 9시에 시작됩니다! 조금만 기다려주세요!',
      ];
    }
  }

  /* 주말 */
  if (days === 0 || days === 6) {
    console.log('주말');
    result = [
      '주말 및 공휴일에는 근무하지 않습니다. 방문이 필요하지 않은 업무는 온라인 민원 접수를 활용해주세요!',
      '오늘은 휴무일입니다. 주말 및 공휴일을 제외한 다음 근무일에 방문해주세요!',
      '오늘은 쉬는 날이랍니다. 방문이 필수인 민원 업무는 주말 및 공휴일을 제외한 다음 근무일에 방문해주시길 바랍니다.',
    ];
  }
  /* 여권 */
  if (days === 2 && passport === 'Y') {
    console.log('화요일 여권');
    if (time >= 9 && time < 19) {
      console.log('여권 시간');
      result = [
        '오늘은 저녁 9시까지 여권 발급이 가능합니다. 회사 업무로 방문이 어려우셨던 분들, 얼른 오세요!',
        '오늘은 제가 야근하는 날! 금일 여권 발급은 9시까지 가능합니다.',
        '오늘은 인천 서해구 민원실이 야근하는 날! 시간에 쫒겨 여권 발급을 미뤄두셨던 분들 오늘 방문해주세요.',
      ];
    } else if (time >= 19 && time < 20) {
      console.log('여권 시간');
      result = [
        '야간 업무 마감시간까지 얼마 남지 않았답니다, 걸음을 서둘러주세요.',
        '야간 업무 마감까지 2시간이 채 안 남았네요, 여권 발급이 시급하신 구민 분들께서는 서둘러 방문해주세요!',
        '업무 마감이 2시간도 안 남았어요! 서두르지 않으면 오늘 여권 발급이 힘들지도 몰라요.',
      ];
    } else if (time >= 20 && time < 21) {
      console.log('여권 야간 마감 전');
      result = [
        '민원실 연장 업무가 1시간도 안 남았어요. 매주 화요일은 저녁에도 여권을 발급할 수 있습니다.',
        '곧 서해구청의 야간 업무가 끝납니다. 오늘은 업무 처리가 힘들 수도 있는 점 양해 부탁드려요!',
        '인천 서해구청의 연장 민원실은 매주 화요일마다 21시까지 운영되고 있습니다.',
      ];
    } else if (time >= 21 && time < 24) {
      console.log('여권 야간 근무마감');
      result = [
        '금일 야간 업무는 마감되었어요. 아쉽지만 다음 주 화요일에 다시 뵐게요!',
        '금일 야간 업무가 마감되었어요. 저녁에 여권 업무를 보실 예정이라면 다음 주 화요일에 다시 와주세요!',
        '여권 발급 야간 업무가 마감되었습니다. 연장 민원실은 매주 화요일에 운영되는 점 꼭 기억해주세요!',
      ];
    } else {
      console.log('여권 근무시간 외');
      result = [
        '여권 발급 업무는 오전 9시부터 오후 9시까지입니다. 방문 접수는 잠시만 기다려주세요.',
        '여권 발급 업무는 곧 시작된답니다. 방문를 원하시는 구민분들께서는 조금만 기다려 주세요.',
        '여권 발급 업무는 오전 9시부터 오후 9시까지 입니다. 금일 방문 접수를 원하시는 구민분께서는 조금만 기다려 주세요.',
      ];
    }
  }
  return result;
};







